'use client'

import { motion } from 'framer-motion'

const capabilities = [
  {
    title: 'Predictive Demand',
    description:
      'Know your 8am rush before it arrives. Our models forecast occupancy, demand, and load; so you pre-position, staff, and price before the problem forms.',
  },
  {
    title: 'Dynamic Pricing',
    description:
      'Every empty space is lost revenue. Real-time yield optimization across parking, EV charging, amenities, and transit fares; prices that move with demand.',
  },
  {
    title: 'Real-Time Dispatch',
    description:
      'The right vehicle, staff, or resource in the right place, before the request arrives. Not reactive dispatch. Pre-positioned operations.',
  },
  {
    title: 'Digital Twin',
    description:
      'A live model of your entire operation. Every gate, vehicle, space, and ticket visible in real time, and acted on automatically, without a phone call.',
  },
  {
    title: 'Multilingual Engagement',
    description:
      'Your operation runs in Helsinki or KSA. Same platform, same logic — adapted for language, regulation, and local routing. We have deployed in both. No rebuild required.',
  },
  {
    title: 'Proactive Maintenance',
    description:
      'Your equipment tells us it is failing before it fails. Automated ticketing, escalation, and resolution; your team handles the exception, not the routine.',
  },
]

const FeaturesSection = () => {
  return (
    <section className="py-24 bg-[#07090f]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-xs font-mono tracking-widest text-[#00c8ff] uppercase mb-4">
            Capabilities
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#e2e8f0] tracking-tight">
            Vertical Depth Over{' '}
            <span className="text-[#00c8ff]">Horizontal Breadth</span>
          </h2>
          <p className="mt-4 text-[#94a3b8] max-w-xl mx-auto text-lg">
            We are not trying to be ChatGPT for everyone. We are the experts in
            physical operations.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {capabilities.map((cap, i) => (
            <motion.div
              key={cap.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="p-8 rounded-xl border border-[#1c2333] bg-[#0d1117] hover:border-[#00c8ff]/20 transition-colors"
            >
              <h3 className="text-lg font-semibold text-[#e2e8f0] mb-3">
                {cap.title}
              </h3>
              <p className="text-base text-[#94a3b8] leading-relaxed">
                {cap.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeaturesSection
